import * as React from "react";
import cx from "classnames";
import { useHistory, useLocation } from "react-router-dom";
import Burger from "../../../components/burger";
import BackButton from "../../../components/back-button";

import styles from "./header.module.css";

interface IProps {
  className?: string;
  isMenuOpen?: boolean;
  setIsMenuOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  pageTitle?: string;
  TitleComponent?: any;
  RightButton?: any;
  goBack?: string;
}

function Header({
  className,
  isMenuOpen,
  setIsMenuOpen,
  pageTitle,
  TitleComponent,
  RightButton,
  goBack
}: IProps) {
  const history = useHistory();
  const location = useLocation();

  // Treat top-level landings (root and dashboard) as "home" — burger menu,
  // no back button. /dashboard is reachable directly via the sidebar and via
  // the / → /dashboard redirect, so it's a landing in both flows.
  const isHome =
    location.pathname === "/" || location.pathname === "/dashboard";
  function toggleMenu() {
    if (setIsMenuOpen) {
      setIsMenuOpen(m => !m);
    }
  }
  return (
    <div id="header" className={cx(styles.container, className)}>
      <div className={styles.header}>
        {isHome ? (
          <Burger isOpen={isMenuOpen || false} onClick={toggleMenu} />
        ) : (
          <BackButton
            onClick={() =>
              goBack ? history.replace(goBack) : history.goBack()
            }
          />
        )}
        {!TitleComponent && (
          <div className={styles.title}>{pageTitle || "Logbook Admin"}</div>
        )}
        {TitleComponent && <TitleComponent />}
        {RightButton ? <RightButton /> : <div className={styles.empty} />}
      </div>
    </div>
  );
}

export default Header;
